import { render, staticRenderFns } from "./host.vue?vue&type=template&id=a1f78978"
import script from "./host.vue?vue&type=script&lang=js"
export * from "./host.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports